module.exports = __webpack_public_path__ + "static/media/mio_allenatore_preferito2.b861e456.jpg";